export const ERROR_MESSAGES = {
  COMPANY_SOURCES:
    'We ran into an issue fetching the source data for the company. Please try again later.',
  COMPANY_SOURCE_PROPERTIES:
    'We ran into an issue fetching the property data for this source. Please try again later.',
  COMPANY_SOURCE_PROPERTIES_NOT_FOUND:
    'No properties associated with the company and this source.',
  ADD_SOURCE:
    'We were unable to add the source to the company source list. Please try again later.',
  REMOVE_SOURCE:
    'We were unable to remove the source from the company source list. Please try again later.',
  ALL_SOURCES:
    'An unexpected error occurred when fetching a list of sources. Please try again later.',
  COMPANY_SOURCES_NOT_FOUND: 'There are no sources to display yet.',
  CANNOT_DELETE_SOURCE:
    'Removal cannot proceed because this source is enabled for one or more leasing teams. Disable this source for all leasing teams to remove it.',
};

export const COMPANY_SOURCE_MODE = {
  ADD: 'add',
  REMOVE: 'remove',
};

export const COMPANY_SOURCE_TEXT_BUTTON = {
  [COMPANY_SOURCE_MODE.ADD]: 'Add Source',
  [COMPANY_SOURCE_MODE.REMOVE]: 'Remove Source',
};
